import { useModalV2 } from 'common/modal/hooks/useModalV2';

export const useBiasConfirmation = () => {
  const { openModal, closeModal } = useModalV2();

  const showBiasedSearchBlocked = (message: string) =>
    openModal({
      title: message,
      subtitle: 'Remove references to protected characteristics when sourcing.',
      primaryButtonText: 'Close',
      onPrimaryAction: () => closeModal(),
      // Nothing to cancel: the search is refused, closing is the only action.
      secondaryButtonProps: { hidden: true }
    });

  return { showBiasedSearchBlocked };
};
